<script>
  export let text = null;
  export let active = true;
  export let type = "button";
  export let secondary = false;
</script>

{#if text}
  <button
    {type}
    class:secondary
    class={active ? "" : "disabled"}
    disabled={!active}
    on:click
  >
    {text}
  </button>
{:else}
  <button
    class:secondary
    class={active ? "" : "disabled"}
    disabled={!active}
    {type}
    on:click
  >
    <slot />
  </button>
{/if}

<style>
  button {
    margin: 0;
    padding: 0 24px;
    background-color: inherit;
    border: 1px solid #828282;
    font-size: 14px;
    white-space: nowrap;
    line-height: 55px;
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 0.08rem;
    border-radius: 0;
    border: 1px solid #828282;
    color: #fff;
    cursor: pointer;
    user-select: none;
    background: #828282;
    transition: all 0.2s ease-in-out;
  }

  button.secondary {
    background-color: white;
    color: #828282;
  }

  button:hover {
    background-color: black;
    color: white;
    border-color: black;
  }

  button.disabled:hover {
    background: rgba(130, 130, 130, 0.4);
    cursor: auto;
  }

  button.disabled {
    background-color: rgba(130, 130, 130, 0.4);
    border: none;
  }

  button.secondary.disabled {
    background-color: white;
    border: 1px solid rgba(130, 130, 130, 0.4);
    color: rgba(130, 130, 130, 0.4);
  }

  @media only screen and (min-width: 600px) {
    button {
      min-width: 255px;
      padding: 0 48px;
    }
  }
</style>
